import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../commons/ButtonProgress';
import { useStyles } from '../styles';

function PlanActions(props) {
    const {
        isFreeOrTrialPlan,
        isUpgrading,
        onAddExtraServices,
        onUpgradePlan,
    } = props;

    const classes = useStyles();

    return (
        <div className={classes.actionsRow}>
            {!isFreeOrTrialPlan && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onAddExtraServices}
                    showProgress={isUpgrading}
                    label="+ Add extra services"
                />
            )}
            <Button
                variant="outlined"
                color="primary"
                onClick={onUpgradePlan}
                showProgress={isUpgrading}
                label="Upgrade Plan"
            />
        </div>
    );
}

PlanActions.propTypes = {
    isFreeOrTrialPlan: PropTypes.bool,
    isUpgrading: PropTypes.bool,
    onAddExtraServices: PropTypes.func,
    onUpgradePlan: PropTypes.func,
};

PlanActions.defaultProps = {
    isFreeOrTrialPlan: false,
    isUpgrading: false,
    onAddExtraServices: () => {},
    onUpgradePlan: () => {},
};

export default PlanActions;
